import React from 'react';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Paper,
    Typography,
    Box
} from '@mui/material';

export interface MetabolicIndicator {
    parameter: string;
    result: number;
}

interface MetabolicIndicatorsEditorProps {
    data: MetabolicIndicator[];
    onChange: (index: number, field: keyof MetabolicIndicator, value: string) => void;
}

const MetabolicIndicatorsEditor: React.FC<MetabolicIndicatorsEditorProps> = ({ data, onChange }) => {
    
    const displayData = Array.isArray(data) ? data : [];

    return (
        <TableContainer component={Paper} sx={{ maxHeight: '70vh', overflow: 'auto' }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Parameter</TableCell>
                        <TableCell>Result</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {displayData.map((item, index) => {
                        // Ensure item is an object with the required properties
                        const parameter = item?.parameter || '';
                        const result = typeof item?.result === 'number' ? item.result : 0;
                        
                        return (
                            <TableRow key={index}>
                                <TableCell>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        value={parameter}
                                        onChange={(e) => onChange(index, 'parameter', e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        type="number"
                                        size="small"
                                        fullWidth
                                        value={result}
                                        onChange={(e) => onChange(index, 'result', e.target.value)}
                                        inputProps={{ 
                                            step: '0.01',
                                            min: '0'
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
            {displayData.length === 0 && (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography color="textSecondary">No metabolic indicators data available</Typography>
                </Box>
            )}
        </TableContainer>
    );
};

export default MetabolicIndicatorsEditor;
